import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,_vm._b({attrs:{"label":"Taxes","value":_vm.value,"items":['Zero rate', 'Before taxes', 'After taxes']},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }